var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeopleSystem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "89px",
    height: "89px",
    viewBox: "0 0 89 89",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "people-system") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.8195 0.8608 19.898 0.8608 19.898 28.9998 0.8195 28.9998"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "people-system",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(22.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.879,11.3399 C17.879,7.9199 15.119,6.2999 12.179,6.2999 L7.379,6.2999 L7.379,16.3789 L12.179,16.3789 C15.059,16.3789 17.879,14.8189 17.879,11.3399 L17.879,11.3399 Z M13.379,-0.0001 C19.379,-0.0001 25.319,3.8999 25.319,11.1589 C25.319,18.3599 19.379,22.3189 13.379,22.3189 L7.379,22.3189 L7.379,38.2779 L0,38.2779 L0,-0.0001 L13.379,-0.0001 Z",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(26.000000, 9.758800)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.8195,20.2998 C2.9795,21.9798 6.1585,23.2998 9.2785,23.2998 C11.3195,23.2998 12.6985,22.2198 12.6985,20.8398 C12.6985,19.3398 11.6185,18.4998 9.5785,17.8398 C4.2985,16.0998 1.2395,13.5798 1.2395,9.0798 C1.2395,4.1598 5.1985,0.8608 10.8395,0.8608 C14.0185,0.8608 17.1985,1.8208 18.3985,2.5408 L17.1385,8.0608 C15.8785,7.2798 13.7785,6.4408 11.2585,6.4408 C9.3995,6.4408 8.2585,7.4008 8.2585,8.7798 C8.2585,10.1008 9.2185,10.8208 11.3795,11.4808 C17.0785,13.2798 19.8985,16.0398 19.8985,20.6598 C19.8985,25.1598 16.5385,28.9998 9.6385,28.9998 C6.2185,28.9998 3.6395,28.2198 1.5995,27.0798 L0.8195,20.2998 Z",
    id: "Fill-3",
    fill: "#FCBC00",
    mask: "url(#mask-2)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleSystem);
export default __webpack_public_path__ + "static/media/people-system.7fbc7713b13adc29c3fb63f91aef0006.svg";
export { ForwardRef as ReactComponent };